module.exports = __webpack_public_path__ + "static/media/mundo-sofia.e67680d1.jpg";